export default __webpack_public_path__ + "static/media/OnlineStudentPortal.3561c5e8.jpg";